<template>
  <div>
    <v-menu/>
    <!-- <div v-if="!isStaff" class="top-head container-fluid"/> -->
    <div  class="content">
      <mdb-container  style="margin-top:56x">
        <router-view :key="$route.fullPath"/>
      </mdb-container>
      <loader v-if="loading" />
    </div>
    <div style="height:100px"/>
  </div>
</template>
<script>
import { mdbContainer } from 'mdbvue';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import vMenu from '@/views/Menu.vue';
import Footer from '@/views/Footer';
import { LOGIN, CHECK } from '@/store/modules/auth/AuthType'
import Loader from './components/Loader.vue';
export default {
  components: { vMenu, mdbContainer, Loader },
  data: () => ({
    orgs: []
  }),
  computed: {
    ...mapState('auth', ['training']),
    ...mapState('loader', ['loading']),
    ...mapGetters('auth', ['isStaff'])
  },
  methods: {
    ...mapMutations('auth', [LOGIN, 'setProfile', 'restoreAuth']),
    ...mapMutations('training', ['restoreTraining']),
    ...mapActions('auth', [CHECK]),
    // 상태복원
    restore (profile) {
      this.setProfile(profile)
      this.restoreAuth()
      this.restoreTraining()
    },
    isJoin () {
      // http://lcoalhost:4000/join/multi/authsuccess?EncodeData=AgAFQUQ3MDQnRA8EcRV8VioeXVZOu162rKFkv1uBkbeI8j6MMkBlzSn9XJeBIbxoYqQdgt8rECMbAGf%2FniX1dxerHsRsWJpyWiWLji1xCxfG24QbWVwISjv3TizhmyMm4jZk68fqYNDBy4VgospO1Kd5as68gkkp3KaDIsoaBq5H1Mlpon%2BI0tG9CuvwUDNVqzRqx10ssSTU3sI5LmXC%2F90iEWLt5eHe1EQOhqDx6tRiP7ENT8BwFkOpROIzE%2B7hso5WLpaxug86y9LS4cuiqYxghgRqq07F9qJJqMO9XqsC0r9V6WCDaMs57I9o%2BuwGfPs6X27sKfIVWbkzYTXcn3MmhRHfrHaxCJYCoKzkefQbbJ0SnE4SdGoclpGaigcgSgAyLpfl30EHETolLWX1q1xZlvG0CUgcX4NUfnjxBgjZY7DBeqB3kOTU9%2BhCgniTmlC3NdF5PXwtiobJNizrbq2BPMtHH9MDSjuzCpxj2ujXasPUQGO%2F%2FAbCA63oIRHMVcfDnHVOL%2FfID4P66lufa7GHD%2FpVODBeZJr9YtrHZh8cXwivCwXj4w%3D%3D
      // console.log(this.$route.name)
      return this.$route.name && this.$route.name.startsWith('Join')
    }
  },
  async created () {
    if (!this.isJoin()) {
      // 서버에 체크
      try {
        // console.log('유효성 검사')
        const profile = await this.check();
        if (!profile.userId) {
          // console.log('로그 아웃 됨')
          this.$router.push({ name: 'Login' });
        } else {
          // console.log('유효성 통과, 상태 복원')
          this.restore(profile)
        }
      } catch (e) {
        if (this.$route.name !== 'Login') {
          this.$router.push({ name: 'Login' })
        }
      }
    } else {
      // console.log('org 가입')
    }
  },
  watch: {
    loading () { }
  }
}
</script>

<style>
@import url(http://fonts.googleapis.com/earlyaccess/nanumgothic.css);
/* @import url(http://fonts.googleapis.com/earlyaccess/nanumgothiccoding.css);
@import url(http://fonts.googleapis.com/earlyaccess/nanummyeongjo.css);
@import url(http://fonts.googleapis.com/earlyaccess/nanumbrushscript.css);
@import url(http://fonts.googleapis.com/earlyaccess/nanumpenscript.css);
@import url(http://cdn.jsdelivr.net/font-nanum/1.0/nanumbarungothic/nanumbarungothic.css); */

* {
  font-family: 'Nanum Gothic Coding', '맑은 고딕';
  /* font-size: 15px; */
}
.flyout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
}
body, .content {
  width: 100%;
  height: 100%;
}
body {
  /* background-image: url('/images/back2.jpg'); */
  background-repeat: no-repeat;
}
.top-head {
  height: 150px;
  background-image: url('/images/back3.jpg');
  background-repeat: x-repeat;
}
.page-title {
  font-weight: 800;
  color: #0d47a1
}
.table-header th{
  font-weight: 900;
  color: #0d47a1;
}

.page-title {
  font-size: 22px;
  font-weight: 900;
  color: #0d47a1;
}
.sub-title {
  font-size: 18px;
  font-weight: 900;
  color: #0d47a1;
}

.title {
  font-size: 16px;
  font-weight: 900;
  color: #0d47a1;
}

.subject-name {
  font-weight: 900;
  color: #0d47a1;
}
.clock {
  color: gray
}

.bottom-line, .underline {
  border-bottom: solid 1px gainsboro
}
.bolder {
  font-weight:900
}
.pointer {
  cursor: pointer;
  color: blue;
}

.w-10 {
  width: 10%
}
.w-20 {
  width: 20%
}
.w-30 {
  width: 30%
}
.w-40 {
  width: 40%
}
.w-60 {
  width: 60%
}
.w-70 {
  width: 70%
}
.w-80 {
  width: 80%
}
.w-90 {
  width: 90%
}
.select-underline {
  border: 0px;
  outline: none;
  border-bottom: solid 1px;
  border-color: #ced4da;
}
.input-underline {
  border: 0px;
  border-bottom: solid 1px;
  border-color: #ced4da;
  outline: none;
}

input.underline {
  color: #343a40;
  border: 0;
  outline: none;
  border-bottom: solid 1px;
  border-color: #ced4da;
  width: 100%;
  margin: 2px 0
}
input.underline:focus {
  color: #343a40;
  border: 0;
  outline: none;
  border-bottom: solid 2px;
  border-color: #007bff;
  width: 100%;
  margin: 2px 0

}
.pointer:hover {
  color: red;
}

table.table th {
  font-size: 16px;
  font-weight: 900;
  color: #0d47a1;
}

.v-list > .active {
  font-weight: 900;
}
.v-list > .active::before {
  content: "▶ ";
  margin-left: -1.3em;
}
.list.active::before {
  content: "▶ ";
  margin-left: -1.4em;
}
body {
  width: 100%;
  height: 100%;
}
.loader {
  background-color: rgba(0,0,0,.2);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}
.spinner-border {
  position: fixed;
  top: 30%;
  left: 50%;
}
.fsize-m  td, .fsize-m th  {
  font-size: 15px
}
.left-cell {
  display: table-cell;
}
.left-cell-auto {
  display: table-cell;
  width: auto
}
.right-cell {
  display: table-cell;
}
.right-cell-auto {
  width: auto;
  display: table-cell;
}
</style>
